import { useTheme } from '../../hooks/useTheme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PageNotFound = () => {
  var {
    colors
  } = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    height: "100%",
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "70",
      cy: "70",
      r: "54",
      fill: colors.illustration.light
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_11086_277",
      maskUnits: "userSpaceOnUse",
      x: "16",
      y: "16",
      width: "108",
      height: "108",
      children: /*#__PURE__*/_jsx("circle", {
        cx: "70",
        cy: "70",
        r: "54",
        fill: colors.illustration.light
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask0_11086_277)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M72.0001 80.4208V145.077H68.0001V80.4208H72.0001Z",
        fill: colors.illustration.stroke
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M71.9023 81.0386L50.9023 145.695L47.0979 144.459L68.0979 79.803L71.9023 81.0386Z",
        fill: colors.illustration.stroke
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M68.0979 81.0386L89.0979 145.695L92.9023 144.459L71.9023 79.803L68.0979 81.0386Z",
        fill: colors.illustration.stroke
      }), /*#__PURE__*/_jsx("path", {
        d: "M82 78.5364C82 85.1638 76.6274 90.5364 70 90.5364C63.3726 90.5364 58 85.1638 58 78.5364C58 71.909 63.3726 66.5364 70 66.5364C76.6274 66.5364 82 71.909 82 78.5364Z",
        fill: colors.illustration.bg
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M70 86.5364C74.4183 86.5364 78 82.9547 78 78.5364C78 74.1181 74.4183 70.5364 70 70.5364C65.5817 70.5364 62 74.1181 62 78.5364C62 82.9547 65.5817 86.5364 70 86.5364ZM70 90.5364C76.6274 90.5364 82 85.1638 82 78.5364C82 71.909 76.6274 66.5364 70 66.5364C63.3726 66.5364 58 71.909 58 78.5364C58 85.1638 63.3726 90.5364 70 90.5364Z",
        fill: colors.illustration.stroke
      })]
    }), /*#__PURE__*/_jsx("path", {
      d: "M20.1598 66.0598C19.8639 64.9384 20.5312 63.7824 21.6504 63.4779L46.5208 56.7108C47.6399 56.4063 48.787 57.0685 49.0829 58.1899L52.9431 72.8194C53.239 73.9409 52.5716 75.0968 51.4525 75.4013L26.5821 82.1685C25.463 82.473 24.3159 81.8108 24.02 80.6893L20.1598 66.0598Z",
      fill: colors.illustration.bg
    }), /*#__PURE__*/_jsx("path", {
      d: "M45.4635 52.8794C45.1676 51.758 45.835 50.602 46.9541 50.2975L78.9145 41.6012C80.0336 41.2966 81.1807 41.9589 81.4766 43.0803L88.2622 68.7966C88.5581 69.918 87.8908 71.0739 86.7717 71.3784L54.8112 80.0748C53.6921 80.3793 52.545 79.7171 52.2491 78.5956L45.4635 52.8794Z",
      fill: colors.illustration.bg
    }), /*#__PURE__*/_jsx("path", {
      d: "M77.433 39.6011C77.1371 38.4796 77.8044 37.3237 78.9235 37.0192L111.303 28.2089C112.422 27.9044 113.569 28.5666 113.865 29.688L123.032 64.4277C123.327 65.5491 122.66 66.705 121.541 67.0095L89.1616 75.8199C88.0425 76.1244 86.8954 75.4621 86.5995 74.3407L77.433 39.6011Z",
      fill: colors.illustration.bg
    }), /*#__PURE__*/_jsx("path", {
      d: "M125.327 71.8979C124.208 72.2024 123.06 71.5401 122.765 70.4187L110.556 24.1507C110.26 23.0293 110.927 21.8733 112.047 21.5688L118.213 19.8911C119.332 19.5865 120.479 20.2488 120.775 21.3702L132.983 67.6382C133.279 68.7596 132.612 69.9156 131.493 70.2201L125.327 71.8979Z",
      fill: colors.illustration.bg
    }), /*#__PURE__*/_jsx("path", {
      d: "M20.0073 89.1098C18.8882 89.4143 17.7411 88.752 17.4452 87.6306L11.0167 63.2679C10.7208 62.1465 11.3882 60.9905 12.5073 60.686L18.6733 59.0082C19.7925 58.7037 20.9395 59.366 21.2354 60.4874L27.6639 84.8501C27.9598 85.9716 27.2925 87.1275 26.1733 87.432L20.0073 89.1098Z",
      fill: colors.illustration.bg
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.1586 65.7098C20.5809 63.5204 21.0074 61.5832 23.1923 60.9887L43.8763 55.4013C46.0612 54.8068 48.3008 56.0997 48.8785 58.2891L52.7387 72.9187C53.3164 75.1081 52.0135 77.3649 49.8286 77.9594L29.1446 83.5469C26.9597 84.1414 25.5966 82.5287 25.0188 80.3393L21.1586 65.7098ZM24.2128 64.8564C24.1596 64.8709 24.1988 64.803 24.2128 64.8564L26.072 72.2941L28.0021 79.6088C27.9488 79.6233 28.0162 79.6622 28.0021 79.6088L48.8081 74.0918C48.8614 74.0773 48.8931 74.0223 48.879 73.9689L45.0188 59.3393C45.0047 59.2859 44.9501 59.2544 44.8968 59.2689L24.2128 64.8564Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M43.5338 53.4042C42.9561 51.2148 44.259 48.958 46.4439 48.3634L75.5164 40.4515C77.7014 39.857 79.9409 41.1499 80.5187 43.3394L87.3042 69.0556C87.882 71.2451 86.5791 73.5019 84.3941 74.0964L55.3216 82.0083C53.1367 82.6029 50.8971 81.3099 50.3194 79.1205L43.5338 53.4042ZM47.4645 52.2311C47.4112 52.2456 47.3794 52.3006 47.3935 52.354L54.1791 78.0703C54.1932 78.1237 54.2478 78.1552 54.3011 78.1407L83.3736 70.2288C83.4269 70.2143 83.4587 70.1592 83.4446 70.1058L76.659 44.3896C76.6449 44.3362 76.5903 44.3046 76.537 44.3191L47.4645 52.2311Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M75.5033 40.1257C74.9256 37.9363 76.2285 35.6795 78.4134 35.0849L109.019 26.8394C111.204 26.2449 113.443 27.5378 114.021 29.7272L123.188 64.4669C123.765 66.6563 122.462 68.9132 120.277 69.5077L89.6721 77.7532C87.4871 78.3478 85.2476 77.0548 84.6699 74.8654L75.5033 40.1257ZM79.434 38.9526C79.3807 38.9671 79.3489 39.0221 79.363 39.0755L88.5295 73.8152C88.5436 73.8686 88.5982 73.9001 88.6515 73.8856L119.257 65.6401C119.31 65.6256 119.342 65.5705 119.328 65.5171L110.161 30.7774C110.147 30.724 110.093 30.6925 110.039 30.707L79.434 38.9526Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M125.837 73.8313C123.652 74.4258 121.412 73.1328 120.835 70.9434L108.626 24.6754C108.049 22.4859 109.351 20.2291 111.536 19.6346L117.702 17.9568C119.887 17.3623 122.127 18.6553 122.705 20.8447L134.913 67.1127C135.491 69.3022 134.188 71.559 132.003 72.1535L125.837 73.8313ZM124.694 69.8932C124.708 69.9466 124.763 69.9781 124.816 69.9636L130.982 68.2859C131.036 68.2714 131.068 68.2163 131.053 68.1629L118.845 21.8949C118.831 21.8415 118.776 21.81 118.723 21.8245L112.557 23.5022C112.504 23.5167 112.472 23.5718 112.486 23.6252L124.694 69.8932Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.5176 91.0431C18.3326 91.6376 16.0931 90.3447 15.5154 88.1553L9.08691 63.7925C8.5092 61.6031 9.81211 59.3463 11.997 58.7518L18.1631 57.074C20.348 56.4795 22.5876 57.7724 23.1653 59.9618L29.5938 84.3246C30.1715 86.514 28.8686 88.7709 26.6836 89.3654L20.5176 91.0431ZM19.375 87.1051C19.3891 87.1585 19.4438 87.19 19.497 87.1755L25.6631 85.4977C25.7164 85.4832 25.7482 85.4282 25.7341 85.3748L19.3056 61.012C19.2915 60.9586 19.2369 60.9271 19.1836 60.9416L13.0176 62.6194C12.9643 62.6339 12.9325 62.6889 12.9466 62.7423L19.375 87.1051Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      d: "M45.4644 17.6032C45.5208 17.0323 46.2729 16.8643 46.5744 17.3553L50.9227 24.436C51.058 24.6564 51.3191 24.7667 51.5709 24.7099L59.9186 22.8267C60.4929 22.6972 60.8961 23.3848 60.4994 23.817L54.8498 29.9732C54.6691 30.1701 54.6422 30.4635 54.7839 30.6919L59.125 37.6902C59.4316 38.1844 58.9283 38.7774 58.3894 38.5569L50.4931 35.3261C50.259 35.2303 49.9908 35.2902 49.8217 35.4761L44.1187 41.7448C43.7295 42.1727 43.0152 41.8517 43.0747 41.2757L43.9168 33.1195C43.9443 32.8533 43.7912 32.6002 43.5417 32.4993L35.743 29.3474C35.1954 29.1261 35.2572 28.3347 35.8319 28.2075L44.1878 26.3593C44.4398 26.3035 44.6268 26.0931 44.6521 25.8368L45.4644 17.6032Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("circle", {
      cx: "122",
      cy: "122.438",
      r: "9",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("circle", {
      cx: "45.5",
      cy: "103.814",
      r: "4.5",
      fill: colors.illustration.main
    })]
  });
};
//# sourceMappingURL=PageNotFound.js.map